var api = require("!../../../style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../../../postcss-loader/src/index.js??ruleSet[1].rules[1].use[1]!./tableediting.css");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {"injectType":"singletonStyleTag","attributes":{"data-cke":true}};

options.insert = "head";
options.singleton = true;

var update = api(content, options);



module.exports = content.locals || {};